<template>
<div class="swiper-slide-inner">
    <div class="step" v-if="showShop && shopPersonal">
        <p>STEP<span>01</span></p>
    </div>
    <div class="step" v-else-if="showShop || showBrand || showShowroom">
        <p>STEP<span>02</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>メールアドレスを教えて下さい。</span></h3>
                <p>ログインIDとして利用するメールアドレスを入力してください。入力したメールアドレスに確認メールが届きますので、記載されているURLをクリックして会員登録を進めてください。AUMAではなりすましなどを防止するために会社や団体でご利用されているドメインのメールアドレス（メーリングリスト）を登録することを推奨しております。</p>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <input type="email" id="your-email" placeholder=" " v-model="loginEmail">
                    <label for="your-email" class="m-label"><span>メールアドレス</span></label>
                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev" v-on:click="$emit('showPrevSwiper')"><span>Back</span></button>
            <button v-on:click="sendVerificationMail" v-bind:disabled="isInValidEmail" type="button"  v-bind:class="isInValidEmail? '_left' : '_right'" class="js-swiper-next"><span>Send</span></button>
        </div>

    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                loginEmail: '',
                companyType: 0,
            }
        },
        emits:['setDisplayEmail', 'openAlertModal'],
        methods: {
            sendVerificationMail() {
                this.$store.state.verify.form.login_email = this.loginEmail;
                this.$emit('setDisplayEmail', this.$store.state.verify.form.login_email);
                this.$emit('showNextSwiper');
                if (this.showShop) {
                    this.$store.state.verify.form.company_type = 0;
                } else if (this.showBrand) {
                    this.$store.state.verify.form.company_type = 1;
                } else if (this.showShowroom) {
                    this.$store.state.verify.form.company_type = 2;
                }
                axios.post(route('registration.send.verification.email'), {
                    form: this.$store.state.verify.form,
                }).then((res) => {
                    this.$store.state.verify.form.login_email  = res.data.email;
                }).catch((error) => {
                    console.log(error);
                    if (error.response) {
                        this.$emit('openAlertModal', "error", '送信できませんでした', '入力されたメールアドレスにメール送信できませんでした。入力内容に間違いがないかもう一度ご確認お願いします。'); // 確認済み
                    }
                });
            },
            validEmail() {
                const reg = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
                return !reg.test(this.loginEmail);
            }
        },
        computed: {
            isInValidEmail() {
                return this.validEmail();
            },
            showShop() {
                return location.pathname.match(/^\/registration\/shop/);
            },
            showBrand() {
                return location.pathname.match(/^\/registration\/brand/);
            },
            showShowroom() {
                return location.pathname.match(/^\/registration\/showroom/);
            },
            shopPersonal() {
                if (this.$store.state.verify.form.registration_plan === 10) {
                    return true
                } else return false;
            },
        }
    }
</script>
